import { Box, BoxProps } from '@apia/theme';

/**
 * Con el código comentado dentro de FooterButtons se hace
 * que se muestren los botones cuando se está haciendo scroll
 * hacia abajo.
 */

/**
 *
 */
export const FooterButtons = (props: BoxProps) => {
  /* const isScrollingDown = useMatchScrollDirection('down');

  const { Portal } = usePortal({
    containerId: 'NonControlledAppModals',
    clickOutsideToHide: false,
    autoRemoveContainer: false,
    defaultShow: true,
    escToHide: false,
  });

  const sx = React.useMemo<ThemeUIStyleObject>(
    () => ({
      ...(isScrollingDown
        ? {
            bottom: 0,
          }
        : { bottom: '-5000px' }),
      position: 'fixed',
    }),
    [isScrollingDown],
  ); */

  return (
    <>
      {/* <Portal>
        <Box sx={sx} {...props} />
      </Portal> */}
      <Box {...props} />
    </>
  );
};
